(function (app, ng) {

    app.controller("clientFileViewerController", clientFileViewerController);

    clientFileViewerController.$inject = ["directoryApi", "fileApi", "personApi", "$q", "_", "$mdDialog", "$mdSidenav", "$window", "$sce"];
    function clientFileViewerController(directoryApi, fileApi, personApi, $q, _, $mdDialog, $mdSidenav, $window, $sce) {
        var $ctrl = this;
        $ctrl.showSearchResults = false;
        // window.fileviewer = this;

        ng.extend($ctrl,
            {
                ui: {
                    uploading: false,
                    downloading: false,
                    saving: false,
                    reverseSort: false
                },
                close: close,
                addDirectory: addDirectory,
                uploadFiles: uploadFiles,
                expandDirectory: expandDirectory,
                openDirectory: openDirectory,
                setPreviewItem: setPreviewItem,
                deleteItem: deleteItem,
                updateName: updateName,
                refresh: refresh,
                searchFiles: searchFiles,
                clearSearch: clearSearch,
                download: download,
                toggleSideNav: toggleSideNav
            });

        function close() {
            $mdDialog.cancel();
        }

        function addDirectory() {
            $ctrl.ui.saving = true;

            var directory = {
                Name: "New Folder",
                IsLocked: false,
                ParentId: $ctrl.ui.currentDirectory.Id,
                Parent: {
                    Id: $ctrl.ui.currentDirectory.Id,
                    Name: $ctrl.ui.currentDirectory.Name,
                    ParentId: $ctrl.ui.currentDirectory.ParentId,
                    Parent: $ctrl.ui.currentDirectory.Parent
                },
                CreatedById: $ctrl.user.Id,
                CreatedBy: $ctrl.user,
                CreatedOn: new Date,
                Children: [],
                Files: [],
                DisplayChildren: true
            }

            if (!$ctrl.ui.currentDirectory.Children)
                $ctrl.ui.currentDirectory.Children = [];

            $ctrl.ui.currentDirectory.DisplayChildren = true;
            $ctrl.ui.currentDirectory.Children.push(directory);
            directoryApi.create(directory).then(function (response) {
                ng.extend(directory,
                    {
                        Id: response.Id,
                    });
                $ctrl.ui.saving = false;
            });
        }

        function uploadFiles(files) {
            $ctrl.ui.uploading = true;
            var promises = [];

            ng.forEach(files,
                function (file) {
                    var directoryFile = {
                        Name: file.name,
                        DirectoryId: $ctrl.ui.currentDirectory.Id,
                        Size: file.size,
                        CreatedById: $ctrl.user.Id,
                        CreatedBy: $ctrl.user,
                        CreatedOn: new Date
                    };

                    if (!$ctrl.ui.currentDirectory.Files)
                        $ctrl.ui.currentDirectory.Files = [];

                    $ctrl.ui.currentDirectory.Files.push(directoryFile);
                    var payload = new FormData();
                    payload.append("directoryFile", file, file.name);

                    promises.push(directoryApi.addFile($ctrl.ui.currentDirectory.Id, payload).then(function (response) {
                        directoryFile.Id = response.Id;
                    }));
                });

            $q.all(promises).then(function () {
                $ctrl.ui.uploading = false;
            });
        }

        function createBreadcrumbs(newBreadcrumbs, dir) {
            newBreadcrumbs.push(dir);

            if (!dir.Parent || dir.Parent === null)
                return _.reverse(newBreadcrumbs);

            return createBreadcrumbs(newBreadcrumbs, dir.Parent);
        }

        function expandDirectory(dir) {
            if (!dir.DisplayChildren) {
                var promises = [];

                if (!dir.Children) {
                    promises.push(directoryApi.getChildren(dir.Id).then(function (response) {
                        dir.Children = response;
                    }));
                }

                $q.all(promises).then(function () {
                    dir.DisplayChildren = true;
                });
            } else {
                dir.DisplayChildren = false;
            }
        }

        function setPreviewItem(item) {
            $ctrl.ui.previewItem = item;
            let fileType = $ctrl.ui.previewItem.Name.split(".").pop();

            let supportedFileTypes = ['jpg', 'jpeg', 'png', 'txt', 'pdf'];

            if ($ctrl.ui.previewItem.Size) {
                ng.extend($ctrl.ui.previewItem, {
                    type: fileType,
                    editableName: item.Name.substring(0, $ctrl.ui.previewItem.Name.lastIndexOf(".")),
                    previewUrl: 'Images/Icons/File-Generic-Icon-Md.svg'
                });

                if (supportedFileTypes.includes(fileType.toLowerCase())) {
                    let safeUrl = $sce.trustAsResourceUrl(fileApi.getFileUrl(item.Id));
                    $ctrl.ui.previewItem.previewUrl = safeUrl;
                }


            } else {
                ng.extend($ctrl.ui.previewItem, {
                    editableName: item.Name,
                    type: 'Folder',
                    previewUrl: $ctrl.ui.previewItem.IsLocked ? '/Images/Icons/Folder-Lock-Icon-Md.svg' : '/Images/Icons/Folder-Icon-Md.svg'
                });
            }
        }

        function openDirectory(dir) {
            $ctrl.clearSearch();
            $ctrl.ui.currentDirectory = dir;
            $ctrl.ui.reverse = false;
            $ctrl.setPreviewItem(dir);
            $ctrl.ui.breadcrumbs = createBreadcrumbs([], dir);

            var promises = [];
            if (!dir.Children || !dir.Files) {
                promises.push(directoryApi.getChildren(dir.Id).then(function (children) {
                    directoryApi.getFiles(dir.Id).then(function (files) {
                        ng.extend(dir,
                            {
                                Children: children,
                                Files: files
                            });
                    });
                }));
            }

            $q.all(promises);
        }

        function deleteItem($event) {
            var type = $ctrl.ui.previewItem.type;

            var confirm = $mdDialog.confirm({
                focusOnOpen: false,
                theme: "confirmDelete",
                title: "Are you sure you want to delete " +
                    $ctrl.ui.previewItem.Name +
                    "?" +
                    (type === "Folder" ? " All sub folders and files will also be deleted." : ""),
                targetEvent: $event,
                ariaLabel: "Confirm " + $ctrl.ui.previewItem.Name + " removal",
                ok: "Delete",
                cancel: "No",
                multiple: true

            });

            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.saving = true;

                if (type !== "Folder") {
                    _.remove($ctrl.ui.currentDirectory.Files, { Id: $ctrl.ui.previewItem.Id });
                    fileApi.delete($ctrl.ui.previewItem.Id).then(function () {
                        $ctrl.ui.saving = false;
                        $ctrl.setPreviewItem($ctrl.ui.currentDirectory);
                    });
                } else {
                    if ($ctrl.ui.previewItem.Id === $ctrl.ui.currentDirectory.Id) {
                        var parent = findParent($ctrl.ui.previewItem.ParentId, $ctrl.rootDirectory);
                        _.remove(parent.Children, { Id: $ctrl.ui.previewItem.Id });
                        $ctrl.ui.currentDirectory = parent;
                        $ctrl.ui.breadcrumbs = createBreadcrumbs([], $ctrl.ui.currentDirectory);
                    } else {
                        _.remove($ctrl.ui.currentDirectory.Children, { Id: $ctrl.ui.previewItem.Id });
                    }

                    directoryApi.delete($ctrl.ui.previewItem.Id).then(function () {
                        $ctrl.ui.saving = false;
                        $ctrl.setPreviewItem($ctrl.ui.currentDirectory);
                    });
                }
            });
        }

        function findParent(directoryId, directory) {
            if (directoryId === directory.Id) {
                return directory;
            }

            return ng.forEach(directory.Children,
                function (child) {
                    var found = findParent(directoryId, child);
                    if (found) {
                        return found;
                    }
                });
        }

        function updateName(item) {
            $ctrl.ui.saving = true;
            item.editName = false;

            if (item.type === "Folder") {
                item.Name = item.editableName;
                directoryApi.update(item.Id, item).then(function () {
                    $ctrl.ui.saving = false;
                });
            } else {
                item.Name = item.editableName + "." + item.Name.split(".").pop();
                fileApi.updateName(item.Id, item).then(function () {
                    $ctrl.ui.saving = false;
                });
            }
        }

        function refresh() {
            $ctrl.clearSearch();

            directoryApi.getChildren($ctrl.ui.currentDirectory.Id).then(function (children) {
                directoryApi.getFiles($ctrl.ui.currentDirectory.Id).then(function (files) {
                    $ctrl.ui.currentDirectory.Children = children;
                    $ctrl.ui.currentDirectory.Files = files;
                });
            });
        }

        function download(file) {
            $ctrl.ui.downloading = true;
            fileApi.get(file.Id).then(function (response) {
                var f = document.createElement("a");
                document.body.appendChild(f);
                f.style = "display: none";

                var fUrl = window.URL.createObjectURL(response);
                f.href = fUrl;
                f.download = file.Name;
                f.click();

                setTimeout(function () {
                    document.body.removeChild(file);
                    window.URL.revokeObjectURL(fUrl);
                },
                    100);
                $ctrl.ui.downloading = false;
            });
        }

        function searchFiles() {
            if ($ctrl.searchTerm.length) {
                $ctrl.ui.searching = true;

                directoryApi.searchFiles($ctrl.rootDirectory.Id, $ctrl.searchTerm).then(function (response) {
                    $ctrl.searchResults = {};
                    $ctrl.searchResults.Directories = _.filter(response,
                        function (r) {
                            return r.type === "directory";
                        });
                    $ctrl.searchResults.Files = _.filter(response,
                        function (r) {
                            return r.type === "file";
                        });

                    $ctrl.showSearchResults = true;
                    $ctrl.ui.searching = false;
                });
            } else {
                $ctrl.clearSearch();
            }
        }

        function clearSearch() {
            $ctrl.searchResults = {};
            $ctrl.showSearchResults = false;
            $ctrl.searchTerm = "";
        }

        function toggleSideNav(sideNavId) {
            $mdSidenav(sideNavId).toggle();
        }

        function getParentRouteIds(ids, dir) {
            ids.push(dir.Id);

            if (!dir.Parent)
                return ids;
            return getParentRouteIds(ids, dir.Parent);
        }

        function createTreeToChild(dir, routeIds, childId) {
            dir.DisplayChildren = true;

            if (dir.Id === childId) {
                directoryApi.getChildren(dir.Id).then(function (children) {
                    directoryApi.getFiles(dir.Id).then(function (files) {
                        dir.Children = children;
                        dir.Files = files;
                    });
                });
            } else {
                directoryApi.getChildren(dir.Id).then(function (children) {
                    dir.Children = children;
                    var routeDir = _.find(children,
                        function (child) {
                            return _.includes(routeIds, child.Id);
                        });

                    createTreeToChild(routeDir, routeIds, childId);
                });
            }
        }

        $ctrl.$onInit = () => {
            if ($ctrl.dirShortcut) {
                $ctrl.ui.currentDirectory = $ctrl.dirShortcut;
                $ctrl.setPreviewItem($ctrl.dirShortcut);
                $ctrl.ui.breadcrumbs = createBreadcrumbs([], $ctrl.dirShortcut);

                var parentIds = getParentRouteIds([], $ctrl.dirShortcut);
                directoryApi.get($ctrl.dirShortcut.RootDirId).then(function (response) {
                    $ctrl.rootDirectory = response;
                    createTreeToChild($ctrl.rootDirectory, parentIds, $ctrl.dirShortcut.Id);
                });
            } else {
                $ctrl.ui.currentDirectory = $ctrl.rootDirectory;
                $ctrl.ui.breadcrumbs = [$ctrl.rootDirectory];            
                $ctrl.setPreviewItem($ctrl.rootDirectory);
            }
        };
    }

})(window.app, window.angular); //jshint ignore:line